/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LicenseUpdate
 */
export interface LicenseUpdate {
    /**
     * 
     * @type {string}
     * @memberof LicenseUpdate
     */
    license_type?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof LicenseUpdate
     */
    is_active?: boolean | null;
    /**
     * ISO 8601 date-time
     * @type {string}
     * @memberof LicenseUpdate
     */
    valid_until?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LicenseUpdate
     */
    notes?: string | null;
}

/**
 * Check if a given object implements the LicenseUpdate interface.
 */
export function instanceOfLicenseUpdate(value: object): value is LicenseUpdate {
    return true;
}

export function LicenseUpdateFromJSON(json: any): LicenseUpdate {
    return LicenseUpdateFromJSONTyped(json, false);
}

export function LicenseUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): LicenseUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'license_type': json['license_type'] == null ? undefined : json['license_type'],
        'is_active': json['is_active'] == null ? undefined : json['is_active'],
        'valid_until': json['valid_until'] == null ? undefined : json['valid_until'],
        'notes': json['notes'] == null ? undefined : json['notes'],
    };
}

export function LicenseUpdateToJSON(json: any): LicenseUpdate {
    return LicenseUpdateToJSONTyped(json, false);
}

export function LicenseUpdateToJSONTyped(value?: LicenseUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'license_type': value['license_type'],
        'is_active': value['is_active'],
        'valid_until': value['valid_until'],
        'notes': value['notes'],
    };
}

